import { getSegmento } from "./generics";

const roles = localStorage.getItem("role")?.split(",");

/**
* Mostrar el menu item en el sidebar dependiendo de los
  roles del usuario
* 
*@param: array_roles: array con los roles permitidos
*@return: booleano. True para mostrar, false para ocultar
*/
export const ShowMenuItem = (array_roles) => {
  return array_roles.filter(value => roles.includes(value)).length > 0 && getSegmento()
}